<template>
  <BaseModal title="购买空间" v-model="show" :width="370">
    <a-form-model-item label="容量(GB)">
      <a-row :gutter="20">
        <a-col :span="15">
          <a-slider v-model="form.gb_count" :min="10" :max="500" :step="10"/>
        </a-col>
        <a-col :span="9">
          <a-input-number v-model="form.gb_count" :min="10" :max="500" :step="10"/>
        </a-col>
      </a-row>
    </a-form-model-item>
    <a-form-model-item label="有效时长">
      <a-radio-group v-model="form.duration" @change="toPay">
        <a-radio-button :value="12">1年</a-radio-button>
        <a-radio-button :value="24">2年</a-radio-button>
        <a-radio-button :value="36">3年</a-radio-button>
        <a-radio-button :value="48">4年</a-radio-button>
        <a-radio-button :value="60">5年</a-radio-button>
        <a-radio-button :value="72">6年</a-radio-button>
      </a-radio-group>
    </a-form-model-item>
    <a-button type="primary" shape="round" size="large" block @click="toPay">确认购买{{ amount|formatCNF }}</a-button>
    <CommonPay ref="pay" :user="user" :wxpay="wxpay" :prepay="prepay" :probe="probe" @paid="afterPaid" title="购买存储空间"/>
  </BaseModal>
</template>

<script>
import api from "../../../../utils/api";
import BaseModal from "../../../../comps/BaseModal";
import DelayLoading from "../../../../comps/DelayLoading";
import CommonPay from "@/comps/CommonPay";

export default {
  name: "BuySpace",
  props: {user: Object},
  components: {CommonPay, BaseModal},
  mixins: [DelayLoading],
  data() {
    return {
      show: false,
      form: {
        gb_count: 10, // GB
        duration: 12, // 月长
      }
    }
  },
  computed: {
    amount() {
      return 25 * this.form.gb_count * this.form.duration;
    }
  },
  methods: {
    open() {
      this.show = true;
    },
    toPay() {
      this.$refs.pay.open(this.amount);
    },
    wxpay() {
      return api.v1.user.space.create(this.form).then(res => {
        return api.v1.user.space.toPay(res.id, {channel: 15});
      });
    },
    prepay() {
      return api.v1.user.space.create(this.form).then(res => {
        return api.v1.user.space.prepay(res.id);
      });
    },
    async probe(id) {
      let res = await api.v1.user.space.isPaid(id);
      return res["is_paid"];
    },
    afterPaid() {
      window.location.reload();
    }
  }
}
</script>

<style scoped lang="less">
.ant-slider {
  margin-top: 10px;
}

.ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
  color: #ffffff;
  background: #1890ff;
}
</style>
